import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { singletonHook } from 'react-singleton-hook';

import { IDrugClass } from '@interfaces/lookups';
import { userDataSelector } from '@store/features/auth/user/selectors';
import { handleGetDrugClasses } from '@store/features/drugClasses/actions';
import {
  drugClassesErrorSelector,
  drugClassesIsLoadingSelector,
  drugClassesIsReadySelector,
  drugClassesSelector,
} from '@store/features/drugClasses/selectors';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useDrugClasses = (): IDrugClass[] => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(drugClassesSelector);
  const isLoading = useSelector(drugClassesIsLoadingSelector);
  const isReady = useSelector(drugClassesIsReadySelector);
  const error = useSelector(drugClassesErrorSelector);
  const user = useSelector(userDataSelector);

  const handleFetch = useCallback(() => {
    !user?.isAdmin && user?.organizationId && dispatch(handleGetDrugClasses());
  }, [dispatch, user]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.drugClassesError'),
    handleFetch,
  });

  return data;
};

export default singletonHook([], useDrugClasses);
